/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for sqlLanguageType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="sqlLanguageType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="cognos"/&gt; &lt;enumeration value="native"/&gt; &lt;enumeration value="passThrough"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SqlLanguageType extends Enum{

	enumValue = null;

	/**
	 * Cognos SQL can be optimized by the system and combined with other SQL before being sent to the data source.
	 */
	static  COGNOS = SqlLanguageType.newLiteral("cognos");

	/**
	 * Native SQL cannot be modified except by macro substitution, but can be combined with other SQL into a single SQL query to send to the data source.
	 */
	static  NATIVE = SqlLanguageType.newLiteral("native");

	/**
	 * Pass-through SQL cannot be modified except by macro substitution, and cannot be combined with other SQL. It must be sent to the data source as a stand-alone query. However, results can be combined with results of other queries.
	 */
	static  PASS_THROUGH = SqlLanguageType.newLiteral("passThrough");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < SqlLanguageType.values().length); ++i) {
			if (SqlLanguageType.values()[i].enumValue == v) {
				return SqlLanguageType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("SqlLanguageType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SqlLanguageType.js